import { addTranslations } from "@app/i18n";
import { useTranslation } from "react-i18next";

const RESOURCE_NAME = "columns";

const keys = addTranslations(RESOURCE_NAME, {
    tooltip_status_validated: {
        en: "Complete",
        fr: "Terminé",
    },
    tooltip_status_in_progress: {
        en: "In progress",
        fr: "En cours",
    },
    tooltip_status_not_started: {
        en: "Not started",
        fr: "Non commencé",
    },
});

export const useColumnsTranslations = () => {
    const { t } = useTranslation(RESOURCE_NAME);

    return { t, keys };
};
